module.exports = __webpack_public_path__ + "img/android.61a4d7b3.png";